module.exports = __webpack_public_path__ + "static/media/logo.841c3124.jpg";